export default {
	save: 'Changes saved successfully',
	error: 'Error. Contact support',
	'old password was incorrect': 'Old password was incorrect',
	templateDuplicated: 'Template successfully duplicated',

}